import React from 'react';
import Button from '@sizeid/commons/components/Button';
import { WithTranslation } from 'next-i18next';

import P from 'components/typo/P';
import { withTranslation } from 'lib/i18n';

import { BUSINESS_SIGN_UP } from '../constants';

import Wrap from './styled/Wrap';
import DesktopTable from './DesktopTable';
import MobileTable from './MobileTable';
import { VARIANTS } from './variants';

const Pricing: React.FC<WithTranslation> = ({ t, i18n }) => (
  <Wrap>
    <DesktopTable variants={VARIANTS} />
    {VARIANTS.map(variant => (
      <MobileTable key={variant.code} variant={variant} />
    ))}
    <P size={-2} italic>
      {t('business.index.pricing.info')}
    </P>
    <Button link={BUSINESS_SIGN_UP(i18n.language)} giant>
      {t('business.index.pricing.start_using')}
    </Button>
  </Wrap>
);

export default withTranslation('pages')(Pricing);
